/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Tile_FlowInputs */

const tr_landing_telegram_tile_flow = /** @type {(inputs: Landing_Telegram_Tile_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek sohbette onay → imza → yazdırma: GİB e-Arşiv taslağı, imzası ve iletimi otomatik.`)
};

const en_landing_telegram_tile_flow = /** @type {(inputs: Landing_Telegram_Tile_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve → sign → print in one chat: the GİB e-Arşiv draft, signature and delivery run automatically.`)
};

const de_landing_telegram_tile_flow = /** @type {(inputs: Landing_Telegram_Tile_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen → signieren → drucken in einem Chat: GİB-e-Arşiv-Entwurf, Signatur und Übermittlung laufen automatisch.`)
};

const ru_landing_telegram_tile_flow = /** @type {(inputs: Landing_Telegram_Tile_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждение → подпись → печать в одном чате: черновик e-Arşiv для GİB, подпись и передача выполняются автоматически.`)
};

/**
* | output |
* | --- |
* | "Approve → sign → print in one chat: the GİB e-Arşiv draft, signature and delivery run automatically." |
*
* @param {Landing_Telegram_Tile_FlowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_tile_flow = /** @type {((inputs?: Landing_Telegram_Tile_FlowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Tile_FlowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_tile_flow(inputs)
	if (locale === "de") return de_landing_telegram_tile_flow(inputs)
	if (locale === "ru") return ru_landing_telegram_tile_flow(inputs)
	return tr_landing_telegram_tile_flow(inputs)
});